import React, { JSX } from 'react';
import { SearchFacet, SearchSortOption } from './../../../types/search';
import SearchSortBy from './SearchSort';

interface SearchDesktopFiltersProps {
  facets: SearchFacet[];
  appliedFacets?: SearchFacet[];
  onToggleFacet: (facetKey: string) => void;
  onFacetItemToggle: (facetKey: string, itemValue: string) => void;
  labels: {
    applyFilters: string;
    clearFilters: string;
    showingLabel?: string;
    filterByLabel?: string;
    sortByLabel?: string;
  };
  sortOptions?: SearchSortOption[];
  sortOrder?: string;
  setSortOrder?: (order: string) => void;
  showClearAll?: boolean;
}

function SearchDesktopFilters({
  facets,
  onFacetItemToggle,
  labels,
  sortOptions,
  sortOrder,
  setSortOrder,
}: Readonly<SearchDesktopFiltersProps>): JSX.Element {
  const { filterByLabel } = labels;

  return (
    <div className="search__filters">
      <div className="search__filters-headings-wrapper">
        {facets && facets.length > 0 && (
          <div className="search__filters-headings">
            <div className="search__filters-label">{filterByLabel}</div>
            {facets.map(facet => (
              <div key={facet.key} className="search__filters-list">
                <ul className="search__filters-list-items">
                  {facet.items.map(item => {
                    const isChecked = !!item.isSelected;
                    const valueStr = String(item.value);
                    const inputId = `facet-${facet.key}-${valueStr}`;
                    return (
                      <li
                        key={valueStr}
                        className={
                          isChecked
                            ? 'search__filters-filter search__filters-filter--selected'
                            : 'search__filters-filter'
                        }
                      >
                        <label htmlFor={inputId} className="search__filters-filter-label">
                          <input
                            id={inputId}
                            type="checkbox"
                            checked={isChecked}
                            // IMPORTANT: don't block on total===0; only respect explicit hide
                            disabled={!!item.hide}
                            onChange={() => onFacetItemToggle(facet.key, valueStr)}
                            className="search__filters-checkbox"
                          />
                          <span className="custom-checkbox" aria-hidden="true" />
                          <span>{item.label ?? valueStr}</span>
                        </label>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>
        )}
        {sortOptions && sortOptions.length > 0 && sortOrder && setSortOrder && (
          <SearchSortBy options={sortOptions} selected={sortOrder} onChange={setSortOrder} labels={labels} />
        )}
      </div>
    </div>
  );
}

export default SearchDesktopFilters;
